import { useContext, useEffect,useState } from "react";
import { getDataFromStorage } from "../../../../util";
import AlertContext from "../../../../context/AlertContext";
import MenuBarHooks from "../../../../Hooks/MenuBar/MenuBarHooks";
import { SOALearningModules } from "./SOAComponents/SOAStudentLearningModuleSection/SOALearningModules";
import { SOAFullComponent } from "./SOAComponents/SOADashboard/SOAFullComponent";
import LeetCode from "../../../CommonComponents/LeetCode";
import SOAActivity from "./SOAComponents/SOADashboard/SOAActivity";
import SOAHackathons from "./SOAComponents/SOADashboard/SOAHackathons";
import SOACodingChallenge from "./SOAComponents/SOADashboard/SOACodingChallenge";
import SOAMockTests from "./SOAComponents/SOADashboard/SOAMockTests";
import SOAJobsInternships from "./SOAComponents/SOADashboard/SOAJobsInternships";
import LearningStreak from "../../../CommonComponents/LearningStreak";
import constants from "../../../../constants";

export const SOADashboard = () => {

  const companyId = parseInt(localStorage.getItem("companyId"));
  const stored = localStorage.getItem("account_response");

    const [enabledFeatures,setEnableFeatures]=useState([])
  
    useEffect(()=>{
      if (stored) {
      try {
        const decoded = JSON.parse(atob(stored));
  
        // axios response structure
        const selectedCompany = decoded || {};
  
        // const companyId = parseInt(localStorage.getItem("companyId"));
  
        // const selectedCompany = companies.find(c => c.id === companyId);
  
        if (selectedCompany && selectedCompany.premium_features) {
          const features = JSON.parse(selectedCompany.premium_features);
  
          setEnableFeatures(features.map(
            (feature) => feature.premium_feature_name??feature.premium_features??feature.name
          ));
          localStorage.setItem(
            "enabled_features",
            btoa(JSON.stringify(features))
          );
  
        }
  
      } catch (error) {
        console.error("Error decoding accounts_response:", error);
      }
    }
    },[])

  // Feature flags

 

  // menu visibility checks


  const hasCodingChallenges = enabledFeatures.includes("coding_challenges");

  const hasMockTests =
    enabledFeatures.includes("mcq") ||
    enabledFeatures.includes("descriptive") ||
    enabledFeatures.includes("coding_challenge_test") ||
    enabledFeatures.includes("video_test");

  const hasAIInterviews = enabledFeatures.includes("ai_interviews");

  const hasJobs = enabledFeatures.includes("jobs_internships");

  const hasHackathons =enabledFeatures.includes("hackathons");

  const showPracticeMenu = (hasCodingChallenges || hasMockTests || hasAIInterviews);

  const showExploreMenu = (hasJobs || hasHackathons);

  const name = getDataFromStorage("name"); //Student Name

  const isContenIsLoading = false; //For skeletons

  const Alert = useContext(AlertContext);
  const MenuBarHks = MenuBarHooks();
  useEffect(() => {
    Alert.setDashBoardDetails([]);
    MenuBarHks.handleDashBoard(true);
  }, []);

  const dashboardData = Alert.dashBoardDetails;
  const completeAssignmentsData = Alert.completeAssignmentsData[0] || {};

  const percentage =
    completeAssignmentsData?.Total_count > 0
      ? Math.round(
        (completeAssignmentsData?.Completed_count /
          completeAssignmentsData?.Total_count) *
        100
      )
      : 0;
  const batchType = localStorage.getItem("batchType");

  return (
    <>
      {isContenIsLoading ? (
        <></>
      ) : (
        dashboardData && (
          <div className="SOAMainContainer">
            <header className="SOAHeader">
              {getDataFromStorage("role") === constants.Roles.parent ? (
                <>
                  <div>{`Hello, ${getDataFromStorage("name")}’s parent!`}</div>
                  <div className="SOAHeaderProgress">
                    You can track your child’s progress here...
                  </div>
                </>
              ) : (
                <>{`Hey ${name}!`}</>
              )}
            </header>

            {Alert.dashBoardDetails?.batchDetails?.length > 0 && 
            Alert.dashBoardDetails?.lpData?.length > 0 && (
              <section className="SOALearningModulesContainer">
                <SOALearningModules />
              </section>
            )}

            <section className="SOAOverview SOALearningActivity">
              <LearningStreak />
              {Alert.ActivityData?.length>0 && (
                <SOAActivity data={Alert.ActivityData} />
              )}
            </section>

            {dashboardData?.taskDueLists?.length>0 &&(
              <SOAFullComponent
                from="assignmentdue"
                data={dashboardData?.taskDueLists}
                percentage={percentage}
              />
            )}
            {/* {batchType && batchType === constants.BATCH_TYPE.LEARNING && 
             dashboardData?.upComingEvents?.length > 0 && (
              <section className="SOAOverview">
                <SOAFullComponent from="upcomingsessions" data={dashboardData?.upComingEvents} />
              </section>
            )} */}
            <div className="sectioncards">
              {/* <section className="SOAOverview"> */}
                {hasMockTests && <SOAMockTests />}
                {hasJobs && <SOAJobsInternships />}
              {/* </section> */}
              {/* <section className="SOAOverview"> */}
                {hasCodingChallenges && <SOACodingChallenge />}
                {hasHackathons && <SOAHackathons />}
              {/* </section> */}
            </div>

            {/* {(hasHackathons || hasCodingChallenges ) && (<section className="SOAOverview SOACodingHAckathons">
              {hasCodingChallenges && <SOACodingChallenge />}
              {hasHackathons && <SOAHackathons />}
            </section>)} */}

            {parseInt(batchType) !== constants.BATCH_TYPE.TESTING ? (
              <section className="SOAleetcode">
                <LeetCode />
              </section>
            ) : null}
          </div>
        )
      )}
    </>
  );
};
